import { useEffect } from 'react';
import AuthService from './auth';

// R1C: an admin is signed out of every tab after 60 minutes with no activity.
// Activity in ANY admin tab counts: the last-activity time lives in
// localStorage, which every tab of this browser shares. Signing out clears the
// session, and authSync signs out the other tabs too.
export const ADMIN_IDLE_MS = 60 * 60 * 1000;
const KEY = 'zaynic_admin_last_activity';
const CHECK_EVERY_MS = 30 * 1000;
const WRITE_THROTTLE_MS = 15 * 1000;
const EVENTS = ['mousedown', 'keydown', 'scroll', 'touchstart', 'mousemove'];

function readLast() {
  try {
    const v = Number(window.localStorage.getItem(KEY));
    return Number.isFinite(v) && v > 0 ? v : null;
  } catch {
    return null;
  }
}

function writeLast(ts) {
  try {
    window.localStorage.setItem(KEY, String(ts));
  } catch {
    /* storage unavailable: this tab still tracks its own activity */
  }
}

export function useAdminIdleLogout(enabled) {
  useEffect(() => {
    if (!enabled) return undefined;
    let localLast = Date.now();
    let lastWrite = 0;
    // A stale value from a long-closed admin tab must not sign us out on load.
    writeLast(localLast);

    const onActivity = () => {
      localLast = Date.now();
      if (localLast - lastWrite > WRITE_THROTTLE_MS) {
        lastWrite = localLast;
        writeLast(localLast);
      }
    };
    const check = () => {
      const last = Math.max(localLast, readLast() || 0);
      if (Date.now() - last >= ADMIN_IDLE_MS) {
        try {
          window.localStorage.removeItem(KEY);
        } catch {
          /* ignore */
        }
        AuthService.logout('/admin-login?reason=idle');
      }
    };

    EVENTS.forEach((e) => window.addEventListener(e, onActivity, { passive: true }));
    document.addEventListener('visibilitychange', check);
    const timer = window.setInterval(check, CHECK_EVERY_MS);
    return () => {
      EVENTS.forEach((e) => window.removeEventListener(e, onActivity));
      document.removeEventListener('visibilitychange', check);
      window.clearInterval(timer);
    };
  }, [enabled]);
}
